import { constants, rem, Styles, theme } from '@/styles';

export const styles: Styles = {
  color: theme.error,
  fontSize: rem(constants.fontSize.p),
  minHeight: 14,
};
